import React from 'react';

export const EventContentRenderer = React.memo(({ content, className }) => {
  return (
    <div
      className={className}
      dangerouslySetInnerHTML={{ __html: content }}
    />
  );
});

EventContentRenderer.displayName = 'EventContentRenderer';
